export const SEO_ROUTES = {
  index: 'https://www.joeyfamily.com/',
  articles: 'https://www.joeyfamily.com/articles',
  pricing: 'https://www.joeyfamily.com/pricing',
  about: 'https://www.joeyfamily.com/about-us',
  contact: 'https://www.joeyfamily.com/contact',
  terms: 'https://www.joeyfamily.com/terms',
  privacy: 'https://www.joeyfamily.com/privacy',
  security: 'https://www.joeyfamily.com/security',
  faqs: 'https://www.joeyfamily.com/faqs',
  founders: 'https://www.joeyfamily.com/founders',
  getStarted: 'https://www.joeyfamily.com/get-started',
  plansBasic: 'https://www.joeyfamily.com/plans/basic',
  plusComingSoon: 'https://www.joeyfamily.com/plus-coming-soon',
  smartAlerts: 'https://www.joeyfamily.com/features/smart-alerts',
  iphoneMonitoring: 'https://www.joeyfamily.com/features/iphone-monitoring',
  iphoneMonitoringParentalControls: 'https://www.joeyfamily.com/features/iphone-monitoring/parental-controls',
  iphoneMonitoringSnapchat: 'https://www.joeyfamily.com/features/iphone-monitoring/snapchat',
  iphoneMonitoringYouTubeGoogle: 'https://www.joeyfamily.com/features/iphone-monitoring/youtube-google',
  iphoneMonitoringJoeyDesktop: 'https://www.joeyfamily.com/features/iphone-monitoring/joey-desktop',
  imessageMonitoring: 'https://www.joeyfamily.com/imessage-monitoring-for-parents',
  analytics: 'https://www.joeyfamily.com/features/analytics',
  contactVerification: 'https://www.joeyfamily.com/features/contact-verification',
  howsMyChild: 'https://www.joeyfamily.com/features/hows-my-child-report',
  smartAlertsSuspiciousContacts: 'https://www.joeyfamily.com/features/smart-alerts/suspicious-contacts',
  smartAlertsConcerningLanguage: 'https://www.joeyfamily.com/features/smart-alerts/concerning-language-hate-speech',
  smartAlertsEmotionalDistress: 'https://www.joeyfamily.com/features/smart-alerts/emotional-distress',
  smartAlertsMoneyGifts: 'https://www.joeyfamily.com/features/smart-alerts/money-and-gifts',
  smartAlertsPersonalInformation: 'https://www.joeyfamily.com/features/smart-alerts/personal-information',
  smartAlertsDrugsAlcohol: 'https://www.joeyfamily.com/features/smart-alerts/drugs-and-alcohol',
} as const

export type SeoRouteKey = keyof typeof SEO_ROUTES
